module.exports = __webpack_public_path__ + "assets/swagger.78429129.svg";